import { Schedule as ScheduleIcon } from "assets/icons";
import { WidgetType } from "types/Widget";

import { ScheduleItemData } from "./interfaces";
import { OrganiseScheduleSetting } from "./OrganiseScheduleSetting";
import { Scheduler, SchedulerState } from "./Scheduler";
const REACT_APP_PARENT_ORIGIN = process.env.REACT_APP_PARENT_ORIGIN || "https://topteacher.com.au/";
export const DefaultSchedule: ScheduleItemData = {
  id: "default",
  activity: "English Class",
  color: "#7FDFDB",
  time: "2023-09-18T23:00:00.000Z",
  link: REACT_APP_PARENT_ORIGIN,
  image: "👩‍🏫",
};

export const SchedulerWidget: WidgetType<SchedulerState> = {
  name: "Schedule",
  component: Scheduler,
  icon: ScheduleIcon,
  showOnToolbar: true,
  sizing: {
    minWidth: 150,
    minHeight: 150,
    minAspectRatio: 0.3,
    maxAspectRatio: 1,
  },
  defaultState: {
    completed: {},
  },
  defaultSize: {
    aspectRatio: 0.6,
    widthPercentage: 15,
  },
  settings: {
    organise: {
      editor: OrganiseScheduleSetting,
      info: {},
      defaultValue: {
        loadKey: -1,
      },
    },
  },
  quickActions: {},
};
